import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-cb2fbd4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-layout" }
const _hoisted_2 = {
  ref: "modalImage",
  class: "modal-image center"
}
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "taskcard" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/ico/calendar.svg" }, null, -1))
const _hoisted_6 = { class: "taskcard-title" }
const _hoisted_7 = {
  key: 0,
  class: "taskcard-text"
}
const _hoisted_8 = {
  key: 1,
  class: "taskcard-text"
}
const _hoisted_9 = { class: "taskcard" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/ico/calendar.svg" }, null, -1))
const _hoisted_11 = { class: "taskcard-title" }
const _hoisted_12 = {
  key: 0,
  class: "taskcard-text"
}
const _hoisted_13 = {
  key: 0,
  style: {"margin-left":"8px"},
  class: "indicator red"
}
const _hoisted_14 = {
  key: 1,
  class: "taskcard-text"
}
const _hoisted_15 = { class: "taskcard" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/ico/profile.svg" }, null, -1))
const _hoisted_17 = { class: "taskcard-title" }
const _hoisted_18 = {
  key: 0,
  class: "taskcard-text"
}
const _hoisted_19 = {
  key: 1,
  class: "taskcard-text"
}
const _hoisted_20 = { class: "taskcard" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/ico/box.svg" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "taskcard-title" }, "Module", -1))
const _hoisted_23 = { class: "taskcard-text" }
const _hoisted_24 = { class: "container" }
const _hoisted_25 = {
  key: 0,
  class: "grid wide"
}
const _hoisted_26 = ["onClick", "src"]
const _hoisted_27 = { class: "text-muted" }
const _hoisted_28 = {
  key: 0,
  class: "indicator green"
}
const _hoisted_29 = {
  key: 1,
  class: "indicator red"
}
const _hoisted_30 = {
  key: 1,
  class: "grid wide"
}
const _hoisted_31 = { class: "text-muted" }
const _hoisted_32 = { class: "row2" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  key: 1,
  class: "text-red"
}
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 2 }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = {
  key: 2,
  class: "grid wide"
}
const _hoisted_41 = ["onClick", "src"]
const _hoisted_42 = {
  key: 3,
  class: "grid wide"
}
const _hoisted_43 = { class: "row" }
const _hoisted_44 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_45 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_46 = { class: "text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavHeader = _resolveComponent("NavHeader")!
  const _component_SeModal = _resolveComponent("SeModal")!
  const _component_WideCard = _resolveComponent("WideCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NavHeader, {
      backButton: "true",
      title: "Task"
    }),
    _createVNode(_component_SeModal, {
      title: "Image",
      ref: "imageModal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", _hoisted_2, null, 512)
      ]),
      _: 1
    }, 512),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.Lang.getI18N("expected-date")), 1),
        (_ctx.endDate != null)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.dateFormat(_ctx.endDate, "dd/mm/yyyy HH:MM")), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_8, "--"))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.Lang.getI18N("submission-date")), 1),
        (_ctx.submissionDate != null)
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
              _createTextVNode(_toDisplayString(_ctx.dateFormat(_ctx.submissionDate, "dd/mm/yyyy HH:MM")) + " ", 1),
              (_ctx.TaskManager.isTaskLate(_ctx.state.task!))
                ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_14, "--"))
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.Lang.getI18N("employee")), 1),
        (_ctx.completedEmployee != null)
          ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.completedEmployee.name + " " + _ctx.completedEmployee.surname), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_19, "-- "))
      ]),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _hoisted_22,
        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.state.task!.module), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      (_ctx.state.task!.module == _ctx.ModuleEnum.Action)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (result, index) => {
              return (_openBlock(), _createBlock(_component_WideCard, {
                key: index,
                icon: "/ico/action.svg",
                title: result.action
              }, {
                footer: _withCtx(() => [
                  _createElementVNode("img", {
                    onClick: ($event: any) => (_ctx.displayModal(result.url)),
                    class: "traceability-img",
                    src: result.url
                  }, null, 8, _hoisted_26),
                  _createElementVNode("h1", _hoisted_27, [
                    (result.done)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28))
                      : (_openBlock(), _createElementBlock("div", _hoisted_29))
                  ])
                ]),
                _: 2
              }, 1032, ["title"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.state.task!.module == _ctx.ModuleEnum.Temperatures)
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (result, index) => {
              return (_openBlock(), _createBlock(_component_WideCard, {
                key: index,
                icon: result.element?.getIllustrationUrl(),
                title: result.element?.getName()
              }, {
                body: _withCtx(() => []),
                subtitle: _withCtx(() => [
                  _createTextVNode(_toDisplayString(result.comment), 1)
                ]),
                footer: _withCtx(() => [
                  _createElementVNode("h1", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      (result.firstTemperature != null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                            _createTextVNode("Première : "),
                            _createElementVNode("b", null, _toDisplayString(result.firstTemperature) + " °C", 1)
                          ]))
                        : _createCommentVNode("", true),
                      (
                    result.temperature <
                      result.element.getMinimumTemperature() ||
                    result.temperature > result.element.getMaximumTemperature()
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            (result.temperature != null)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                                  _createTextVNode("Prise : "),
                                  _createElementVNode("b", null, _toDisplayString(result.temperature) + " °C", 1)
                                ]))
                              : (_openBlock(), _createElementBlock("b", _hoisted_36, "Non prise"))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            (result.temperature != null)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                                  _createTextVNode("Prise : "),
                                  _createElementVNode("b", null, _toDisplayString(result.temperature) + " °C", 1)
                                ]))
                              : (_openBlock(), _createElementBlock("b", _hoisted_39, "Non prise"))
                          ]))
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["icon", "title"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.state.task!.module == _ctx.ModuleEnum.Traceability)
        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (result, index) => {
              return (_openBlock(), _createBlock(_component_WideCard, {
                key: index,
                icon: "/ico/equipement.svg",
                title: result.element.getName()
              }, {
                body: _withCtx(() => []),
                footer: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(result.pictures, (picture, index) => {
                    return (_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("img", {
                        onClick: ($event: any) => (_ctx.displayModal(picture.url)),
                        class: "traceability-img",
                        src: picture.url
                      }, null, 8, _hoisted_41)
                    ]))
                  }), 256))
                ]),
                _: 2
              }, 1032, ["title"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.state.task!.module == _ctx.ModuleEnum.Oils)
        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (result, index) => {
              return (_openBlock(), _createBlock(_component_WideCard, {
                key: index,
                icon: result.element?.getIllustrationUrl(),
                title: result.element?.getName()
              }, {
                body: _withCtx(() => [
                  _createElementVNode("div", _hoisted_43, [
                    (result.cleaned)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_44, " • " + _toDisplayString(_ctx.Lang.getI18N("cleaned")), 1))
                      : _createCommentVNode("", true),
                    (result.oil_changed)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_45, " • " + _toDisplayString(_ctx.Lang.getI18N("oil-changed")), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                footer: _withCtx(() => [
                  _createElementVNode("span", _hoisted_46, [
                    _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("polarity")) + " : ", 1),
                    _createElementVNode("b", null, _toDisplayString(result.polarity) + "%", 1)
                  ])
                ]),
                _: 2
              }, 1032, ["icon", "title"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}